// $('#form_contact').submit(function() {
//     // we stoped it
//     event.preventDefault();
//     // needs for recaptacha ready
//     grecaptcha.ready(function () {
//         // do request for recaptcha token
//         // response is promise with passed token
//         grecaptcha.execute(G_recaptcha, {action: 'form_contact'}).then(function (token) {
//             // add token to form
//             $('#form_contact').prepend('<input type="hidden" name="token" value="' + token + '">');
//             $('#form_contact').prepend('<input type="hidden" name="action" value="form_contact">');
//             // submit form now
//             $('#form_contact').unbind('submit').submit();
//         });
//     });
// });